var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"prominent":"","type":"error","dismissible":""},on:{"input":_vm.deleteError}},[_c('h2',[_vm._v("Sorry, an error has occured:")]),(_vm.msg.component)?_c('h5',[_vm._v("registered by "+_vm._s(_vm.msg.component))]):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.msg.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }